/*
 * File: d:\projects\AutoFiFront\src\Hooks\UseFavIds.ts
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday February 27th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday February 27th 2023 11:25:55 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { useCallback, useState } from "react";
import Cookie from "Cookies/CookieWrapper";
import CookiePathResolver from "Config/Cookies/CookiePathResolver";

function useFavIds() {
  const cookies = Cookie.getCookie(CookiePathResolver.CAR.FAVORITE);
  const [favIds, setFavIds] = useState(
    cookies != undefined && cookies != null ? cookies : []
  );

  const setCookie = useCallback(
    (id: number, isLiked: boolean) => {
      let myIds: number[];
      if (favIds == undefined) myIds = [];
      else myIds = favIds;

      if (isLiked) {
        myIds.splice(myIds.indexOf(id), 1);
        setFavIds(myIds);
        Cookie.setCookie(CookiePathResolver.CAR.FAVORITE, myIds);
      }

      if (!isLiked) {
        myIds.push(id);
        setFavIds(myIds);
        Cookie.setCookie(CookiePathResolver.CAR.FAVORITE, myIds);
      }
    },
    [favIds]
  );

  return [favIds, setCookie];
}

export default useFavIds;
